// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"ebac66c7","850":"e19214d8"}[chunkId] + ".chunk.js";
};